import { render, staticRenderFns } from "./MyCollectionItem.vue?vue&type=template&id=50f0535b&"
import script from "./MyCollectionItem.vue?vue&type=script&lang=js&"
export * from "./MyCollectionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports